angular.module('impactx.catalog').controller('CatalogRuleCheckImportErrorCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    CatalogRuleCheckImportErrorCtrl]);

function CatalogRuleCheckImportErrorCtrl($scope, dataGen, $mdDialog) {
    var self = this;

    dataGen.getData($scope, {cmrliId: self.cmrliId, catId: self.catId}, "/catalog/rulecheckimporterror");

    self.cancel = function () {
        $mdDialog.cancel();
    };
}